import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { LockKeyhole, LockKeyholeOpen } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import useGeneralSettingsStore from '../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { CatalogProductsTestIds } from '../../../../../../utils/testIds/CatalogProducts.testIds';
import { useProductLock } from '../../../../../products/products-details-v2/hooks/useProductLock';
import useSharedEntities from '../../../../../shared-entities/hooks/useSharedEntities';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { useCatalogView } from '../../../v2/contexts/CatalogView.context';
import { CatalogViewMode } from '../../../v2/view/catalogView.types';

const CatalogListLockButton = () => {
  const { translate } = useTranslation();
  const { effectiveMode } = useCatalogView();
  const { isPublicAccess } = useSharedEntities({});
  const { isLocked, isLockEnabled, onClickLock } = useProductLock();
  const productInputLockValue = useGeneralSettingsStore(
    (state) => state.generalSettings.productInputLockValue,
  );

  if (effectiveMode !== CatalogViewMode.LIST || isPublicAccess || !isLockEnabled) {
    return null;
  }

  const message = translate(LangEnum.PRODUCT_INPUT_UNLOCK_MESSAGE, { max: productInputLockValue });

  return (
    <Tooltip TooltipContent={message}>
      <IconButton
        icon={isLocked ? LockKeyhole : LockKeyholeOpen}
        color="secondary"
        shape="round"
        isActive={!isLocked}
        ariaLabel={message}
        testId={CatalogProductsTestIds.PRODUCT_LOCK_BUTTON}
        onClick={onClickLock}
      />
    </Tooltip>
  );
};

export default CatalogListLockButton;
